const configAPI = {
  REACT_APP_API_BASE_URL: window._env_?.REACT_APP_API_BASE_URL,
  REACT_APP_IMAGE_DYNAMIC_URL: window._env_?.REACT_APP_IMAGE_DYNAMIC_URL,
  // Chat API and hub default to the main API host when not set in environment.js
  REACT_APP_CHAT_API_URL: window._env_?.REACT_APP_CHAT_API_URL || window._env_?.REACT_APP_API_BASE_URL,
  REACT_APP_CHAT_HUB_URL: window._env_?.REACT_APP_CHAT_HUB_URL
};

export default configAPI;
